/**
 * @file     VowDataTermsContent.tsx
 * @purpose  The MLS® VOW Data Terms of Use body copy (GVR §9.07 (a)–(g)),
 *           shared between the standalone legal page (VowDataTermsView) and the
 *           in-registration terms step (VowAccessModal) so the presented text is
 *           a single source of truth.
 */

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function VowDataTermsContent() {
  return (
    <Box sx={{ '& p': { mb: 2, color: 'text.secondary', lineHeight: 1.7 } }}>
      <Typography component="p">
        This site is operated by Ray Rasouli, a licensed real estate
        professional with Real Broker B.C. Ltd. and a member of The Canadian
        Real Estate Association and Greater Vancouver REALTORS®.
      </Typography>

      <Typography component="p">
        These Terms of Use govern access to MLS® VOW Data (such as sold prices,
        listing history, and member-only property details) made available on
        this site by a member of Greater Vancouver REALTORS® (GVR). By
        registering and providing your name, telephone number, and a valid
        email address, you agree to the following.
      </Typography>

      <Typography component="p">
        1. You consent to the collection, use, and disclosure of your personal
        information (including your name, telephone number, and email address)
        for the purpose of providing access to MLS® VOW Data, as described in
        our <Box component="a" href="/privacy" sx={{ color: 'primary.main' }}>Privacy Policy</Box>.
      </Typography>
      <Typography component="p">
        2. You acknowledge entering into a lawful REALTOR®/consumer or
        REALTOR®/client relationship with the brokerage or salesperson
        operating this site.
      </Typography>
      <Typography component="p">
        3. You have a bona fide interest in the purchase, sale, or lease of real
        estate of the type offered through this site.
      </Typography>
      <Typography component="p">
        4. All data obtained from this site is intended for, and may only be
        used for, your personal, non-commercial use.
      </Typography>
      <Typography component="p">
        5. You will not, and will not permit or assist others to, directly or
        indirectly: copy, redistribute, or retransmit any of the data; display,
        post, distribute, publish, sell, or sublicense any of the data to
        another person; or engage in screen scraping, database scraping, data
        mining, or any other activity intended to collect, store, reorganize,
        summarize, or manipulate the data.
      </Typography>
      <Typography component="p">
        6. You acknowledge GVR’s ownership of, and the validity of GVR’s
        proprietary rights and copyright in, the MLS® VOW Data and listing
        information.
      </Typography>
      <Typography component="p">
        7. You expressly authorize GVR, or its duly authorized representatives,
        to access this site and the information you provide for the purposes of
        verifying compliance with, and pursuing enforcement of, these Terms of
        Use and all applicable rules, regulations, bylaws, policies, and laws.
      </Typography>
      <Typography component="p">
        These Terms of Use do not impose any financial obligation on you and do
        not create an agency agreement. Any such agreement would be set out
        separately, prominently labelled, and confirmed by you before taking
        effect.
      </Typography>
    </Box>
  );
}
